import request from './request';

export default {
	async getMachines(query) {
		const res = await request.get('/app/machines', query);
		return res;
	}
};
